// extracted by mini-css-extract-plugin
var _1 = "Avatar-v26yY";
var _2 = "AvatarContainer-Z932e";
var _3 = "Avatars-fCw3v";
export { _1 as "Avatar", _2 as "AvatarContainer", _3 as "Avatars" }
